// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Parameters to restrict the transfer options - particularly for interchanging PTRideLeg's by passenger (de: Individuelles Umsteigeverhalten).
 * - TripsByOriginAndDestinationPostBody: all filters supported
 * - ServiceCalendarByOriginAndDestinationRequestBody: only `maxTransfers` supported yet
 * @export
 * @interface TripMobilityFilter
 */
export interface TripMobilityFilter {
    /**
     * Max. number of Vehicle changes. The parameter is relevant between origin and destination or between origin and ptVias[0] if any among all `PTRideLeg's`.
     * @type {number}
     * @memberof TripMobilityFilter
     */
    maxTransfers?: number;
    /**
     * Walking speed when changing Vehicles: 100% means default speed, 200% doubles it and below 100% will reduce changing time below SBB recommendation.
     * - If the calculation does not result in full minutes, it is rounded using 'round half up' method.
     * - See `Trip::fastTransfer` for time risky changes.
     * @type {number}
     * @memberof TripMobilityFilter
     */
    walkSpeed?: number;
    /**
     * Additional time [in min.] on top of default transfer time when changing Vehicle's.
     * @type {number}
     * @memberof TripMobilityFilter
     */
    additionalTransferTime?: number;
    /**
     * Minimum change time [in min.] when changing transport-products. There is no constant default, depends on SBB defined changing time at specific STATION.
     * @type {number}
     * @memberof TripMobilityFilter
     */
    minTransferTime?: number;
    /**
     * Maximum change time at stop in minutes. In realtimeMode=FULL only planned time is considered (by means not guaranteed if dateTimeRt is given).
     * @type {number}
     * @memberof TripMobilityFilter
     */
    maxTransferTime?: number;
}

/**
 * Check if a given object implements the TripMobilityFilter interface.
 */
export function instanceOfTripMobilityFilter(value: object): value is TripMobilityFilter {
    return true;
}

export function TripMobilityFilterFromJSON(json: any): TripMobilityFilter {
    return TripMobilityFilterFromJSONTyped(json, false);
}

export function TripMobilityFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripMobilityFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'maxTransfers': json['maxTransfers'] == null ? undefined : json['maxTransfers'],
        'walkSpeed': json['walkSpeed'] == null ? undefined : json['walkSpeed'],
        'additionalTransferTime': json['additionalTransferTime'] == null ? undefined : json['additionalTransferTime'],
        'minTransferTime': json['minTransferTime'] == null ? undefined : json['minTransferTime'],
        'maxTransferTime': json['maxTransferTime'] == null ? undefined : json['maxTransferTime'],
    };
}

  export function TripMobilityFilterToJSON(json: any): TripMobilityFilter {
      return TripMobilityFilterToJSONTyped(json, false);
  }

  export function TripMobilityFilterToJSONTyped(value?: TripMobilityFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxTransfers': value['maxTransfers'],
        'walkSpeed': value['walkSpeed'],
        'additionalTransferTime': value['additionalTransferTime'],
        'minTransferTime': value['minTransferTime'],
        'maxTransferTime': value['maxTransferTime'],
    };
}

